import { cn } from '@/lib/utils';

interface DayChipsProps {
  /** Chip values in display order — weekday indexes (0–6) or days of month (1–31). */
  options: { value: number; label: string }[];
  selected: number[];
  onChange: (next: number[]) => void;
}

/** Multi-select chip row for picking recurrence days (weekdays or month dates). */
export function DayChips({ options, selected, onChange }: DayChipsProps) {
  function toggle(value: number) {
    onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]);
  }

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          aria-pressed={selected.includes(opt.value)}
          onClick={() => toggle(opt.value)}
          className={cn(
            'min-w-[2.75rem] rounded-md border px-3 py-1.5 text-sm transition-colors',
            selected.includes(opt.value)
              ? 'border-primary bg-primary text-primary-foreground'
              : 'border-border hover:bg-muted/50',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
